// ===== Packages =====

import {
    Node,
    Element,
}                       from 'slate';

// ===== Interfaces =====

import {
    EditorNode,
    AudioNoteOptions,
    AudioNoteNode,
}                       from '../interfaces';

// ** IMPORTANT **: Keep in sync with functions/src/index.ts
const AUDIO_NOTE_NODE_TYPE = 'audio-note';

const isAudioNoteElement = (node: EditorNode | Node): boolean => Element.isElement(node)
    && 'type' in node
    && node.type === AUDIO_NOTE_NODE_TYPE;

const newAudioNoteElement = (options: AudioNoteOptions): AudioNoteNode => {
    const {
        id,
        filePath,
        description,
        uploaded,
        title,
        isPostContentDictation,
        durationMs,
        waveformBars,
    } = options;

    return {
        id,
        type: AUDIO_NOTE_NODE_TYPE,
        filePath: filePath || '',
        title: title || '',
        description: description || '',
        uploaded: uploaded !== false,
        isPostContentDictation: isPostContentDictation === true,
        durationMs: Number.isFinite(durationMs)
            ? Math.max(0, Math.round(durationMs || 0))
            : undefined,
        waveformBars: Array.isArray(waveformBars)
            ? waveformBars
            : undefined,
        children: [{ text: '' }],
    };
};

export default {
    TYPE: AUDIO_NOTE_NODE_TYPE,
    isAudioNoteElement,
    newAudioNoteElement,
};
